<script lang="ts">
    /**
 *
 *
 *
 *
 */
    import Esi from '@shared/components/esi/Esi.svelte';
    import { footerAttributes } from '@tilelist/domain/external-data-attributes/ExternalDataAttributes.ts';

    const src = '/benefit-cinema/teaser/productlist/assets';
</script>

<div class="reptile-benefit-teaser" {...footerAttributes}>
    <Esi {src} />
</div>

<style lang="scss">
    .reptile-benefit-teaser {
        width: 100%;
    }
</style>
